import { useSelector } from 'react-redux';
import useUpdateSelectedDocuments from '../actions/useUpdateSelectedDocuments';

export default function useSelectedDocuments() {
  return {
    updateSelectedDocuments: useUpdateSelectedDocuments(),
    selectedDocuments: useSelector(state => state.layout.selectedDocuments)
  };
}
